<div class="dialog-backdrop" *ngIf="isVisible" (click)="handleBackdropClick($event)" [class.positioned]="position">
  <div class="datetime-picker-dialog" [class.compact]="position" 
    [style.top.px]="position?.top"
    [style.left.px]="position?.left"
    [style.bottom.px]="position?.bottom"
    [style.right.px]="position?.right"
    (click)="$event.stopPropagation()">

    <!-- Form Section -->
    <div class="dialog-body">
      <div class="form-groups">
        <!-- Date Picker -->
        <div class="form-group">
          <div class="calendar-container">
            <div>
              <ngb-datepicker [(ngModel)]="selectedDate" [minDate]="minDate" [maxDate]="maxDate" [displayMonths]="1"
                [showWeekNumbers]="false" [firstDayOfWeek]="7" navigation="arrows" (dateSelect)="onDateSelect($event)">
              </ngb-datepicker>
            </div>
          </div>
        </div>

        <div class="separator-line"></div>
            <!-- Time Picker -->
            <div class="form-group">
              <div class="time-label">
                <i class="pe-7s-clock"></i>
                <span>Time</span>
              </div>
              <div class="time-inputs">
                <input type="number" class="time-input" [(ngModel)]="selectedHour" (ngModelChange)="onHourChange()"
                  min="1" max="12" placeholder="11" />
                <span class="time-separator">:</span>
                <input type="number" class="time-input" [(ngModel)]="selectedMinute" (ngModelChange)="onMinuteChange()"
                  min="0" max="59" placeholder="55" />
                <div class="period-toggle">
                  <button type="button" class="period-btn period-btn-up" [class.active]="selectedPeriod === 'AM'"
                    (click)="setPeriod('AM')">
                    AM
                  </button>
                  <button type="button" class="period-btn period-btn-down" [class.active]="selectedPeriod === 'PM'"
                    (click)="setPeriod('PM')">
                    PM
                  </button>
                </div>
              </div>
            </div>
        <div class="separator-line"></div>

        <!-- Actions Section -->
        <div class="dialog-actions">
          <button type="button" class="btn-primary" [disabled]="!isFormValid()" (click)="handleApply()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>